function createOptionArray(options) {
    return options
        ?.map((curr) => {
        const item = curr.content.items[0];
        const newItem = {
            label: item.items[0].content?.text,
            type: item.data.type,
            payload: item.data.payload,
        };
        return newItem;
    })
        .filter(Boolean);
}

export { createOptionArray };
//# sourceMappingURL=createOprionArray.js.map
